import React from "react";


function Home() {
    return (
        <><div class="uk-container-fluid">
            <img src="/welcome3.jpeg" alt="Learn HTML5" height="30%" width="auto" />
        </div><div class="uk-container uk-padding">
                <h1>Herzlich Willkommen</h1>
                <div class="uk-text-left">
                    <p>Schön, dass Ihr Euch für Kreativität und Kunst interessiert.</p>
                    <p>Für mich ist....</p>
                    <ul>
                        <li><b>Kreativität</b> das Experimentieren und Zusammenfügen unterschiedlicher Materialien und
der damit verbundene Prozess.</li>
                        <li><b>Kunst</b> das Ergebnis des spielerischen und intuitiven Experimentierens mit Materialien.</li>
                    </ul>
                    <p>Auf dieser Webseite findet Ihr Informationen über meine Arbeit, meine Kurse, Angebote und
Geschenkgutscheine.</p>
                </div>
                
            </div></>
        
    );
}

export default Home;